import { render, staticRenderFns } from "./sn-manage.vue?vue&type=template&id=ddac6cc2&scoped=true&"
import script from "./sn-manage.vue?vue&type=script&lang=js&"
export * from "./sn-manage.vue?vue&type=script&lang=js&"
import style0 from "./sn-manage.vue?vue&type=style&index=0&id=ddac6cc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddac6cc2",
  null
  
)

export default component.exports